import { Col, Row } from 'antd';
import {
  MFormSection,
  MTypography,
  LinkAccountButton,
  MyAccountLayout,
  MyAccountSidebarOtherMenuItemKey,
} from 'src/lib';
import { AccountStatusLabel } from 'src/models';
import { Spacing } from 'src/styles';

import { CurrentAccountStatus } from './CurrentAccountStatus';
import { CurrentAccountStatusDescription } from './CurrentAccountStatusDescription';

export const LinkAccountContent = ({
  status,
  isAnyDocumentRequested = false,
  customTypeLabel,
}: {
  status: AccountStatusLabel;
  isAnyDocumentRequested?: boolean;
  customTypeLabel: string;
}) => {
  return (
    <MyAccountLayout sidebarMenuItemKey={MyAccountSidebarOtherMenuItemKey.AccountStatus} title='Account Status'>
      <Row>
        <Col span={24}>
          <MFormSection
            title={<CurrentAccountStatus label={status} />}
            isEditable={false}
            isEditMode={false}
            className={Spacing.mt0}>
            <CurrentAccountStatusDescription />
            <Row gutter={[0, 16]} className={Spacing.mt16}>
              <Col span={24}>
                <MTypography variant='h6' weight='bold'>
                  Account Linking Error
                </MTypography>
              </Col>
              <Col span={24}>
                <MTypography variant='subtitle2'>
                  Your new {customTypeLabel} account has been successfully created. However, we could not automatically
                  link it to your existing username.
                  {isAnyDocumentRequested ? ' Please click the button below to manually link your account.' : ''}
                </MTypography>
              </Col>
              <Col span={24}>
                <LinkAccountButton />
              </Col>
            </Row>
          </MFormSection>
        </Col>
      </Row>
    </MyAccountLayout>
  );
};
